// §4/D149 — zentrale localStorage-Keys der Persistenz + der „Cache-Owner". Der persistierte
// Query-Cache und der Delta-Cursor sind an EINEN User gebunden (cacheOwner). Beim Bootstrap mit
// DERSELBEN Identität bleibt der Cache (Sofort-Paint); bei einem Identitätswechsel/Logout wird er
// (samt Cursor) gepurgt — kein Cross-User-Bleed im selben Browser (D47, Codex-P0/P1). Alle
// Zugriffe sind storage-frei abgesichert (no-op ohne localStorage).

export const PERSIST_CACHE_KEY = "loumy:query-cache:v1";
export const DELTA_CURSOR_KEY = "loumy:delta-cursor:v1";
const OWNER_KEY = "loumy:cache-owner:v1";

// In-Memory-Spiegel des Owners (Codex-R2-P2): ist localStorage geblockt (Privacy-Modus/iframe),
// liefert die Persistenz keinen Wert — ohne Fallback würde der Delta-Sync-Owner-Guard JEDE Antwort
// verwerfen (deltaSync sieht immer null !== userId) ⇒ keine Live-Updates. Der Spiegel hält den
// in DIESER Session gesetzten Owner, damit der Guard auch ohne Storage funktioniert.
let ownerMirror: string | null = null;

/** Der User, dem der aktuell persistierte Cache/Cursor gehört (oder null). */
export function readCacheOwner(): string | null {
  try {
    if (typeof localStorage !== "undefined") return localStorage.getItem(OWNER_KEY);
  } catch {
    /* Storage geblockt → In-Memory-Spiegel */
  }
  return ownerMirror;
}

export function writeCacheOwner(userId: string | null): void {
  ownerMirror = userId;
  try {
    if (typeof localStorage === "undefined") return;
    if (userId === null) localStorage.removeItem(OWNER_KEY);
    else localStorage.setItem(OWNER_KEY, userId);
  } catch {
    /* Storage geblockt → nur der In-Memory-Spiegel trägt */
  }
}

/**
 * Persistierten Client-State vollständig löschen: den Query-Cache-Blob, den Delta-Cursor UND den
 * Owner. Aufgerufen bei Identitätswechsel/Logout (session.tsx). Der Cursor MUSS mit weg — sonst
 * synct der nächste User aus einem fremden Wasserzeichen in den (geleerten) Cache (Lücke).
 */
export function purgePersistedClientState(): void {
  ownerMirror = null; // auch den In-Memory-Spiegel räumen (Codex-R3-P2), sonst bliebe der alte
  // Owner ohne localStorage nach Logout stehen.
  try {
    if (typeof localStorage === "undefined") return;
    localStorage.removeItem(PERSIST_CACHE_KEY);
    localStorage.removeItem(DELTA_CURSOR_KEY);
    localStorage.removeItem(OWNER_KEY);
  } catch {
    /* Storage geblockt */
  }
}
